// Loads the Google Maps JavaScript API (with the Places library) exactly
// once and returns a promise that resolves once window.google is ready.
// Multiple components can call this — subsequent calls reuse the same
// in-flight/loaded script instead of injecting it again.

let loadPromise = null;

export function loadGoogleMaps() {
  if (loadPromise) return loadPromise;

  const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  if (!apiKey) {
    return Promise.reject(new Error("REACT_APP_GOOGLE_MAPS_API_KEY is not set"));
  }

  loadPromise = new Promise((resolve, reject) => {
    if (window.google?.maps?.places) {
      resolve(window.google);
      return;
    }

    const script = document.createElement("script");
    // "geometry" is needed to decode the encoded polylines our backend
    // returns from the Routes API (see getRoute in orderController.js) —
    // pure client-side decoding, no separate billed API call.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,geometry`;
    script.async = true;
    script.onload = () => resolve(window.google);
    script.onerror = () => reject(new Error("Failed to load Google Maps script"));
    document.head.appendChild(script);
  });

  return loadPromise;
}
